import { useAppSelector } from '../../store/hooks';

interface ProfileSectionProps {
    displayName: string;
    onDisplayNameChange: (value: string) => void;
}

const ProfileSection = ({ displayName, onDisplayNameChange }: ProfileSectionProps) => {
    const { user } = useAppSelector((state) => state.auth);

    return (
        <div style={{
            backgroundColor: 'var(--color-surface)',
            border: '1px solid var(--color-border-light)',
            borderRadius: 'var(--radius-lg)',
            padding: 'var(--spacing-lg)',
            boxShadow: 'var(--shadow-sm)'
        }}>
            <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: 'var(--spacing-md)',
                marginBottom: 'var(--spacing-lg)',
                paddingBottom: 'var(--spacing-lg)',
                borderBottom: '1px solid var(--color-border-light)'
            }}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="var(--color-primary-600)">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                </svg>
                <h2 style={{
                    fontSize: '1.25rem',
                    fontWeight: '600',
                    color: 'var(--color-text-primary)',
                    margin: 0
                }}>
                    Profile Information
                </h2>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--spacing-md)' }}>
                <div>
                    <label style={{
                        display: 'block',
                        fontSize: '0.875rem',
                        fontWeight: '500',
                        color: 'var(--color-text-secondary)',
                        marginBottom: 'var(--spacing-xs)'
                    }}>
                        Email
                    </label>
                    <input
                        type="email"
                        value={user?.email || ''}
                        disabled
                        style={{
                            width: '100%',
                            padding: 'var(--spacing-sm) var(--spacing-md)',
                            backgroundColor: 'var(--color-gray-50)',
                            border: '1px solid var(--color-border-light)',
                            borderRadius: 'var(--radius-md)',
                            fontSize: '0.875rem',
                            color: 'var(--color-text-secondary)',
                            cursor: 'not-allowed'
                        }}
                    />
                </div>

                <div>
                    <label style={{
                        display: 'block',
                        fontSize: '0.875rem',
                        fontWeight: '500',
                        color: 'var(--color-text-secondary)',
                        marginBottom: 'var(--spacing-xs)'
                    }}>
                        Display Name
                    </label>
                    <input
                        type="text"
                        value={displayName}
                        onChange={(e) => onDisplayNameChange(e.target.value)}
                        style={{
                            width: '100%',
                            padding: 'var(--spacing-sm) var(--spacing-md)',
                            backgroundColor: 'var(--color-surface)',
                            border: '1px solid var(--color-border-light)',
                            borderRadius: 'var(--radius-md)',
                            fontSize: '0.875rem',
                            color: 'var(--color-text-primary)',
                            transition: 'border-color 200ms ease-in-out'
                        }}
                        onFocus={(e) => e.currentTarget.style.borderColor = 'var(--color-primary-600)'}
                        onBlur={(e) => e.currentTarget.style.borderColor = 'var(--color-border-light)'}
                    />
                </div>
            </div>
        </div>
    );
};

export default ProfileSection;
